import { Component, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import TableHead from '@/components/TableHead/index.vue'
import TableBody from '@/components/TableBody/index.vue'
import Actions from '@/components/Actions/index.vue'
import ResearchModal from './ResearchModal/index.vue'
import fetch from '@/helpers/fetch'
import tableHelper from '@/helpers/table'
import MessageSuccess from '@/components/edit/MessageSuccess/index.vue'

import vSelect from 'vue-select'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faFilter,
	faCaretUp,
	faChevronRight,
	faChevronLeft,
	faFileExcel,
	faCircleInfo,
	faFileCsv,
} from '@fortawesome/free-solid-svg-icons'

Vue.component('v-select', vSelect)

library.add(
	faFilter,
	faCaretUp,
	faChevronRight,
	faChevronLeft,
	faFileExcel,
	faCircleInfo,
	faFileCsv,
)

@Component({
	components: {
		Loader,
		TableHead,
		TableBody,
		ResearchModal,
		MessageSuccess,
	},
})
export default class TributaryMapManagement extends Vue {
	items: null | any[] = null
	options: object | null | any = null
	modalTitle = 'Criar nova pesquisa'

	viewPage = 1
	totalPages = 0
	totalCount = 0
	countPerPage = 100

	async mounted() {
		this.setLoading(true)

		await this.fetchData()

		this.setLoading(false)
	}

	async fetchData() {
		const result = await Promise.all([
			this.onFilter({}),
			fetch.get(
				'/api/thermometer/collections/options?options=company_name,calc_subject,market_sector,law_firm,company_group_name',
			),
			fetch.get('/api/courthouses'),
		])
		const [resData, resOptions, resCourthouses] = result

		if (resOptions.ok && resOptions.data.options) {
			this.options = resOptions.data.options

			if (resCourthouses) {
				this.options.courthouses = resCourthouses.data
			}

			if (this.options) {
				this.fields.forEach((field) => {
					if (field.options && !field.options.length) {
						let options = (this.options as object)[
							field.optionsLabel
						]

						const firstOption = options[0]
						options = options.map((option, index) => {
							return {
								index: index + 1,
								...option,
								exists: true,
							}
						})

						Vue.set(field, 'options', options)
					}
				})
			}
		}

		if (resData.ok && resData.data) {
			this.items = resData.data.thermometer
			this.setCountAndPages(
				resData?.data?.thermometer_aggregate?.aggregate?.totalCount,
			)
		}
	}

	setCountAndPages(totalCount) {
		if (totalCount || totalCount === 0) {
			this.totalCount = totalCount
			this.totalPages = Math.ceil(this.totalCount / this.countPerPage)
		}
	}

	setLoading(loading) {
		this.fields.forEach((field) => {
			Vue.set(field, 'loading', loading)
		})

		if (loading) {
			this.items = getLoadingItems()
		}
	}

	filters: null | object = null
	async onFilter(filter) {
		// this.setLoading(true)

		this.filters = {
			...this.filters,
			...filter,
		}

		const params = createUrlFilterParams(this.filters)

		const url =
			`/api/thermometer/collections/search?items=${this.countPerPage}&page=${this.viewPage}&` +
			params.join('&')

		const res = await fetch.get(url)
		if (res.ok && res?.data?.thermometer) {
			this.setLoading(false)
			this.items = res?.data?.thermometer

			this.setCountAndPages(
				res?.data?.thermometer_aggregate?.aggregate?.count,
			)
		}

		return res
	}

	onEdit(item) {
		this.modalTitle = 'Editar pesquisa'
		const researchModal: any = this.$refs['modal-pesquisa']
		researchModal.open(item)
	}

	onCreate() {
		this.modalTitle = 'Criar nova pesquisa'
		const researchModal: any = this.$refs['modal-pesquisa']

		const today = new Date().toISOString().split('T')[0]

		researchModal.open({
			company_name: null,
			research_date: today,
			cnpj: null,
			multinational: null,
			publicly_traded: null,
			complete_research: null,
			market_sector: null,
			calc_subject: null,
			cnj: null,
			distribution_date: null,
			courthouse: null,
			state: null,
			city: null,
			law_firm: null,
		})
	}

	toDelete: any | null = null
	async onDelete(item) {
		this.deleteSuccess = false
		this.$bvModal.show('modal-delete')
		this.toDelete = item
	}

	deleting = false
	deleteSuccess = false
	async onDeleteConfirm() {
		if (this.toDelete) {
			this.deleteSuccess = false
			this.deleting = true
			const res = await fetch.delete(
				'/api/thermometer/entry/' + this.toDelete.id,
				{},
			)

			this.deleting = false
			if (res.ok) {
				this.deleteSuccess = true
				// recarrega a lista após deletar
				await this.onFilter({})
			}
		}
	}

	fields: any[] = getFields()

	async previous() {
		if (this.viewPage > 1) {
			this.setLoading(true)
			this.viewPage--
			await this.onFilter({})
			this.setLoading(false)
		}
	}

	async next() {
		if (this.viewPage < this.totalPages) {
			this.setLoading(true)
			this.viewPage++
			await this.onFilter({})
			this.setLoading(false)
		}
	}

	downloading = false
	csvHref = ''
	downloadProp = 'pesquisas-mapa-tributario.csv'
	async downloadCSV() {
		this.downloading = true
		const params = createUrlFilterParams(this.filters)

		const url = '/api/thermometer/collections/search?' + params.join('&')
		const res = await fetch.get(url)

		const data = res?.data?.thermometer

		const formattedData = formatDataCsv(data)

		const csvContent = jsonToCSV(formattedData)

		const encodedUri = encodeURI(csvContent)

		this.csvHref = 'data:text/csv;charset=utf-8,\uFEFF' + encodedUri

		const time = new Date().getTime() - 3 * 60 * 60 * 1000

		this.downloadProp =
			'pesquisas-mapa-tributario-' +
			new Date(time).toISOString().substring(0, 16) +
			'.csv'

		await Vue.nextTick()
		const link: any = this.$refs.csvLink

		if (link && link.click) {
			link.click()
		}

		this.downloading = false
	}
}

function formatDate(date) {
	return date?.split('-')?.reverse()?.join('/')
}

function createUrlFilterParams(filter) {
	const params: any = []
	if (filter && typeof filter === 'object') {
		const keys = Object.keys(filter)

		keys.forEach((key) => {
			const value = filter[key]

			if (typeof value !== 'object') {
				if (value || value === false || value === 0) {
					params.push(`${key}=${encodeURIComponent(value)}`)
				}
			} else {
				if (value?.from) {
					params.push(`${key}_from=${encodeURIComponent(value.from)}`)
				}

				if (value?.to) {
					params.push(`${key}_to=${encodeURIComponent(value.to)}`)
				}
			}
		})
	}

	return params
}

function jsonToCSV(list) {
	let csv: any = null
	let firstCsvLine: any = null
	let keys: any = null

	list.forEach((item) => {
		if (!keys) {
			keys = Object.keys(item)
			firstCsvLine = keys.map((key) => {
				let keyName = key
				return keyName + ';'
			})
			firstCsvLine.push('\n')
			csv = firstCsvLine.join('')
		}

		keys.forEach((key) => {
			let value = item[key]
			if (Array.isArray(value)) {
				value = value.join(' + ')
			}

			if (value === null || value === undefined) {
				value = ''
			}

			const isNumbersOnly = /^\d+$/
			if (
				value[0] === '0' &&
				isNumbersOnly.test(value) &&
				value.length !== 1
			) {
				value = "'" + value
			}

			csv += escapeSemicollon(value) + ';'
		})

		csv += '\n'
	})

	return csv
}

function formatDataCsv(list) {
	const fields = getFields()
	const formattedData: any = []

	list.forEach((item) => {
		const formattedItem = {}
		fields.forEach((field) => {
			if (field.onCsv !== false) {
				let value = item[field.fieldName]

				if (field.format) {
					value = field.format(value)
				}

				formattedItem[field.humanName] = value
			}
		})

		formattedData.push(formattedItem)
	})

	return formattedData
}

function escapeSemicollon(string) {
	let value = string

	if (value === null || value === undefined) {
		value = ''
	}

	if (typeof value !== 'string') {
		value = value.toString()
	}

	if (value.includes(';') || value.includes('\n')) {
		value = '"' + value + '"'
	}

	return value
}

function getFields() {
	return [
		{
			humanName: '#',
			fieldName: 'index',
			'min-width': '49px',
			fixedColumn: true,
			loadingPlaceholder: '100',
			loading: true,
			onDatabase: false,
			onCsv: false,
		},

		{
			humanName: 'Empresa',
			fieldName: 'company_name',
			type: 'v-select',
			optionsLabel: 'company_name',
			options: [],
			vSelectLabel: 'name',
			create: {
				model: '',
			},
			filter: {
				model: '',
				filterBy: 'name',
			},
			'max-width': '250px',
			'min-width': '250px',
			fixedColumn: true,
			loadingPlaceholder: 'AAAAAAAAAAAAAAAAAAAAAAAAAAA',
			loading: true,
			colSize: 3,
			unformat(company) {
				return company ? company.name : null
			},
			onDatabase: true,
			createOrder: 2,
			taggable: true,
		},

		{
			humanName: 'Ações',
			fieldName: 'actions',
			component: Actions,
			width: '87px',
			loadingPlaceholder: 'AAAAAAAA',
			loading: true,
			onDatabase: false,
			onCsv: false,
		},

		{
			humanName: 'Grupo',
			fieldName: 'company_group_name',
			type: 'v-select',
			optionsLabel: 'company_group_name',
			options: [],
			vSelectLabel: 'name',
			create: {
				model: '',
			},
			filter: {
				model: '',
				filterBy: 'name',
			},
			'max-width': '250px',
			'min-width': '250px',
			fixedColumn: false,
			loadingPlaceholder: 'AAAAAAAAAAAAAAAAAAAAAAAAAAA',
			loading: true,
			colSize: 3,
			unformat(group) {
				return group ? group.name : null
			},
			onDatabase: true,
			createOrder: 2,
			taggable: true,
		},

		{
			humanName: 'Data de pesquisa',
			fieldName: 'research_date',
			type: 'date',
			format(value) {
				return formatDate(value)
			},
			create: {
				model: '',
			},
			filter: {
				model: '',
			},
			'min-width': '200px',
			loadingPlaceholder: 'AAAAAAAA',
			loading: true,
			colSize: 2,
			onDatabase: true,
			createOrder: 1,
		},

		{
			humanName: 'Conferida',
			hideLabel: true,
			fieldName: 'complete_research',
			getClass(value) {
				return value ? 'text-success' : 'text-danger'
			},
			format(value) {
				return value ? 'Sim' : 'Não'
			},
			type: 'checkbox',
			create: {
				model: '',
			},
			filter: {
				model: '',
			},
			loadingPlaceholder: 'AAAA',
			loading: true,
			colSize: 1,
			onDatabase: true,
			createOrder: 4,
			'min-width': '130px',
		},

		{
			humanName: 'CNPJ',
			fieldName: 'cnpj',
			type: 'input',
			'v-mask': '##.###.###/####-##',
			filter: {
				model: '',
			},
			create: {
				model: '',
			},
			format(cnpj) {
				if (cnpj && cnpj.replace) {
					return cnpj?.replace(
						/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
						'$1.$2.$3/$4-$5',
					)
				}

				return ''
			},
			unformat(cnpj) {
				if (cnpj && cnpj.replace) {
					return cnpj
						.replace(/\./g, '')
						.replace('/', '')
						.replace('-', '')
				}
			},
			loadingPlaceholder: 'AAAAAAAAAAAAAAAAAAAA',
			loading: true,
			colSize: 3,
			onDatabase: true,
			showCNPJOptions: {
				type: 'v-select',
				taggable: true,
			},
			loadingOptions: false,
			vSelectLabel: 'label',
			createOrder: 3,
		},

		{
			humanName: 'CNJ',
			fieldName: 'cnj',
			type: 'input',
			'v-mask': '#######-##.####.#.##.####',
			filter: {
				model: '',
			},
			create: {
				model: '',
			},
			format(cnj) {
				if (cnj && typeof cnj !== 'string') return ''
				return tableHelper.formatCNJ(cnj)
			},
			unformat(cnpj) {
				if (cnpj) {
					return cnpj?.replace(/\./g, '')?.replace('-', '')
				}
			},
			loadingPlaceholder: 'AAAAAAAAAAAAAAAAAAAA',
			loading: true,
			colSize: 3,
			onDatabase: true,
			createOrder: 9,
			clearAfterCreate: true,
		},

		{
			humanName: 'Tese',
			fieldName: 'calc_subject',
			type: 'v-select',
			vSelectLabel: 'name',
			optionsLabel: 'calc_subject',
			options: [],
			filter: {
				filterBy: 'id',
				model: '',
			},
			create: {
				model: '',
			},
			format(item) {
				return item?.name
			},
			unformat(item) {
				return item.id
			},
			'min-width': '250px',
			loadingPlaceholder: 'AAAAAAAAAAAAAAAAAAAA',
			loading: true,
			colSize: 7,
			onDatabase: true,
			createOrder: 10,
			clearAfterCreate: true,
		},

		{
			humanName: 'Setor',
			fieldName: 'market_sector',
			type: 'v-select',
			vSelectLabel: 'name',
			optionsLabel: 'market_sector',
			options: [],
			filter: {
				filterBy: 'id',
				model: '',
			},
			create: {
				model: '',
			},
			format(item) {
				return item?.name
			},
			unformat(item) {
				return item.id
			},
			'min-width': '250px',
			loadingPlaceholder: 'AAAAAAAAAAAAAAAAAAAA',
			loading: true,
			colSize: 8,
			onDatabase: true,
			createOrder: 5,
		},

		{
			humanName: 'Data de distribuição',
			fieldName: 'distribution_date',
			type: 'date',
			format(value) {
				return formatDate(value)
			},
			create: {
				model: '',
			},
			filter: {
				type: 'date-range',
				model: {
					from: '',
					to: '',
				},
			},
			'min-width': '470px',
			loadingPlaceholder: 'AAAAAAAAAA',
			loading: true,
			colSize: 2,
			onDatabase: true,
			createOrder: 8,
			clearAfterCreate: true,
		},

		{
			humanName: 'Tribunal',
			fieldName: 'courthouse',
			type: 'v-select',
			vSelectLabel: 'name',
			optionsLabel: 'courthouses',
			options: [],
			format(item) {
				return item?.name
			},
			unformat(item) {
				return item.id
			},
			create: {
				model: '',
			},
			filter: {
				model: '',
			},
			loadingPlaceholder: 'AAA',
			loading: true,
			colSize: 2,
			onDatabase: true,
			createOrder: 11,
			clearAfterCreate: true,
			'min-width': '150px',
		},

		{
			humanName: 'Estado',
			fieldName: 'state',
			type: 'v-select',
			options: getStates(),
			vSelectLabel: 'name',
			create: {
				model: '',
			},
			filter: {
				model: '',
			},
			loadingPlaceholder: 'AAA',
			loading: true,
			colSize: 2,
			onDatabase: true,
			unformat(item) {
				return item.name
			},
			createOrder: 12,
			clearAfterCreate: true,
			'min-width': '130px',
		},

		{
			humanName: 'Cidade',
			fieldName: 'city',
			type: 'input',
			create: {
				model: '',
			},
			filter: {
				model: '',
			},
			loadingPlaceholder: 'AAAAAA',
			loading: true,
			colSize: 4,
			onDatabase: true,
			createOrder: 13,
			clearAfterCreate: true,
		},

		{
			humanName: 'Escritório',
			fieldName: 'law_firm',
			type: 'v-select',
			vSelectLabel: 'name',
			optionsLabel: 'law_firm',
			options: [],
			format(item) {
				return item?.name
			},
			unformat(item) {
				return item.id ? item.id : item.name
			},
			create: {
				model: '',
			},
			loadingPlaceholder: 'AAAAAA',
			loading: true,
			colSize: 4,
			onDatabase: true,
			createOrder: 14,
			clearAfterCreate: true,
			taggable: true,
		},

		{
			humanName: 'Multinacional',
			fieldName: 'multinational',
			type: 'select',
			options: [
				{ text: '', value: null },
				{ text: 'Sim', value: true },
				{ text: 'Não', value: false },
			],
			getClass(value) {
				return value ? 'text-success' : 'text-danger'
			},
			format(value) {
				return value ? 'Sim' : 'Não'
			},
			create: {
				model: '',
			},
			loadingPlaceholder: 'AAA',
			loading: true,
			colSize: 2,
			onDatabase: true,
			createOrder: 7,
		},

		{
			humanName: 'Capital aberto',
			fieldName: 'publicly_traded',
			type: 'select',
			options: [
				{ text: '', value: null },
				{ text: 'Sim', value: true },
				{ text: 'Não', value: false },
			],
			getClass(value) {
				return value ? 'text-success' : 'text-danger'
			},
			format(value) {
				return value ? 'Sim' : 'Não'
			},
			create: {
				model: '',
			},
			loadingPlaceholder: 'AAA',
			loading: true,
			colSize: 2,
			onDatabase: true,
			createOrder: 6,
		},
	]
}

function getLoadingItems() {
	return [
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
	]
}

function getStates() {
	return [
		{ id: 1, name: 'SP', exists: true },
		{ id: 2, name: 'RJ', exists: true },
		{ id: 3, name: 'MG', exists: true },
		{ id: 4, name: 'AC', exists: true },
		{ id: 5, name: 'AL', exists: true },
		{ id: 6, name: 'AM', exists: true },
		{ id: 7, name: 'AP', exists: true },
		{ id: 8, name: 'BA', exists: true },
		{ id: 9, name: 'CE', exists: true },
		{ id: 10, name: 'DF', exists: true },
		{ id: 11, name: 'ES', exists: true },
		{ id: 12, name: 'GO', exists: true },
		{ id: 13, name: 'MA', exists: true },
		{ id: 14, name: 'MG', exists: true },
		{ id: 15, name: 'MS', exists: true },
		{ id: 16, name: 'MT', exists: true },
		{ id: 17, name: 'PA', exists: true },
		{ id: 18, name: 'PB', exists: true },
		{ id: 19, name: 'PE', exists: true },
		{ id: 20, name: 'PI', exists: true },
		{ id: 21, name: 'PR', exists: true },
		{ id: 22, name: 'RJ', exists: true },
		{ id: 23, name: 'RN', exists: true },
		{ id: 24, name: 'RO', exists: true },
		{ id: 25, name: 'RR', exists: true },
		{ id: 26, name: 'RS', exists: true },
		{ id: 27, name: 'SC', exists: true },
		{ id: 28, name: 'SE', exists: true },
		{ id: 29, name: 'SP', exists: true },
		{ id: 30, name: 'TO', exists: true },
	]
}
